<section class="account-changes" data-testid="account-changes-section">
  <goab-text tag="h1" size="heading-xl" mt="xl" mb="s">
    Account changes and new user requests
  </goab-text>

  <goab-text tag="h2" size="heading-xs" mt="xl" mb="s">
    Account changes in two business days
  </goab-text>

  <goab-text tag="span" size="body-m" mt="none" mb="m">
    Account changes and new accounts requested will be added within two business
    days.
  </goab-text>

  <goab-text tag="h2" size="heading-xs" mt="xl" mb="s">
    Up to five total accounts
  </goab-text>

  <goab-text tag="span" size="body-m" mt="none" mb="m">
    Each facility has an Owner/Operator contact and Accommodation contact. These
    official site contacts have accounts set up by default. Up to three
    additional contacts may be added to ensure coverage for capacity reporting.
    Please ensure that your team can report every week, even in the event of
    illness or during vacations.
  </goab-text>
</section>
